import { deleteStorageFile } from './'

const deleteReplacedFile = async (oldFileUrl, newFileUrl) => {
  oldFileUrl &&
    oldFileUrl !== newFileUrl &&
    (await deleteStorageFile(oldFileUrl))
}

export default deleteReplacedFile
